import * as React from 'react'
import { useHistory } from 'react-router-dom';
import axios from 'axios'

//This component allow user who forget its password to send is mail in order to receive a message to regen its password
export const ForgetPassword: React.FunctionComponent = (props) => {

    let registerJSON = {}
    let history = useHistory()

    const submitRegister= () => {
        axios.post('https://LaurenceBrun.eu.pythonanywhere.com/auth/password/reset/', registerJSON,
        {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        )
        .then(function (response) {
            alert("Un e-mail avec un lien pour réinitialiser votre mot de passe va vous être envoyé rapidement !")
            history.push('/connexion')
        })
        .catch(function(error) {
            alert("Une erreur est survenue ! Vérifier que vous avez bien saisi l'adresse mail de votre compte e-formation")
        })
    }

    const handleSubmit = (event: any) => {
        event.preventDefault()
        if (event.target.email.value && event.target.emailRepeat.value) {
            if (event.target.email.value === event.target.emailRepeat.value) {
                registerJSON = {
                    "email": event.target.email.value
                }
                submitRegister()
            }
            else {
                alert("Vous devez saisir deux fois la même adresse email !")
            }
        }
        else {
            alert('Vous devez remplir tous les champs !')
        } 
    }

    return(
        <div className="Connect">
            <h2>Générer un nouveau mot de passe</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <input type="email" name="email" placeholder="Email" />                    
                </label><br />
                <label>
                    <input type="email" name="emailRepeat" placeholder="Répéter email" />                    
                </label><br />
                <input type="submit" value="réinitialiser mot de passe" className="ConnectButton Connexion" />
            </form>
        </div>
    )
}